import { custom } from 'zod';
import { Entity } from '../entity';

export interface TenantSecurityMethods {
    workbuddy: boolean;
    microsoft: boolean;
    google: boolean;
    passkey: boolean;
    email: boolean;
}

export interface TenantSecuritySettings {
    customise: boolean;
    methods: TenantSecurityMethods;
    exclusions: Entity[];
}

export interface TenantPreventLoginSettings {
    enabled: boolean;
}

export type TenantSecurityMethodKey = keyof TenantSecurityMethods;

export function defaultTenantSecurityMethodValue() {
    return {
        workbuddy: true,
        microsoft: true,
        google: true,
        passkey: true,
        email: true
    };
}

export function defaultTenantSecurity() {
    return {
        customise: false,
        methods: null,
        exclusions: []
    } as TenantSecuritySettings;
}

export function defaultPreventLogin() {
    return {
        enabled: false
    } as TenantPreventLoginSettings;
}